import * as React from 'react'
import FacetedCarousel from './FacetedCarousel/FacetedCarousel'
import SuperHero from './SuperHero/SuperHero'
import AdsCarousel from './AdsCarousel/AdsCarousel'
import BlueBar from './BlueBar'
import * as styles from './Collection.module.scss'
import * as cn from 'classnames'
import { StorefrontStateCollection, FeatureSwitches } from '../../containers/Storefront';

export interface CollectionProps extends StorefrontStateCollection {
  isPhablet: boolean
  collectionKey: number
  showBlueBars: boolean
  isLoading: boolean
  isFrozen: boolean
  fetch: Function
  hoverClass?: string
  featureSwitches: FeatureSwitches
  enrichCollection: Function
  enrichSingleItem: Function
  canLazyLoad?: boolean
  removeItem?: Function
  updateChannelItem?: Function
  canLivePlayback: boolean
  formFactor: string
  requestFocusForHover?: () => void
  resetFocusForHover?: () => void
  collectionHasFocusForHover?: boolean
}

const Collection = (props: CollectionProps) => {
  const { collectionType, items } = props

  switch (collectionType) {
    case 'SuperHero':
      return (<SuperHero
        items={items.filter(item => item && item.image && item.link &&
          item.image.url && item.link.url)}
        hasAltTheme={props.hasAltTheme}
        webUid={props.webUid}
        modelDebug={props.modelDebug} 
        formFactor={props.formFactor}
        isFrozen={props.isFrozen}
      />)
    case 'AdsCarousel':
      return (<AdsCarousel
        left={props.items[0]}
        right={props.items[1]}
      />)
    default:
      return (<FacetedCarousel
        {...props}
        collectionKey={props.collectionKey}
      />)
  }
}

const BlueBarWrapper = (props: CollectionProps) => props.showBlueBars && Boolean(props.collectionMeta) &&
  (<BlueBar {...props.collectionMeta} />)

const CollectionWrapper = (props: CollectionProps) => {
  const hasItems = props && props.items && props.items.length &&
    props.items.filter(i => !i.isRemoved).length
  if (!hasItems) {
    return (<BlueBarWrapper {...props} />)
  }
  return (
    <div className={cn(styles.Collection, 'u-collection tst-collection',
      {
        [styles.filterLoading]: props.isLoading &&
          props.collectionType !== 'SuperHero'
      }, {
        [styles.containsSuperHero]: props.collectionType === 'SuperHero'
      },
      { ['mobile-collection']: props.isPhablet })}>
      <BlueBarWrapper {...props} />
      <Collection {...props} />
    </div>
  )
}

export default CollectionWrapper
